import { genStyleHook } from '../../tools/style';

export default genStyleHook('prefix-phone-select', (token) => {
  const { componentCls, controlHeightLG, paddingXS } = token;

  return {
    [componentCls]: {
      [`${componentCls}-prefix`]: {
        width: controlHeightLG * 2 + paddingXS,
      },
    },
  };
});
